import { useCallback } from 'react'
import { useDispatch, useSelector } from 'store'
import * as PageAction from 'slicers/PageSlice'
import { voidBooleanF, voidF, voidStringF } from 'types/FunctionTypes'
import { response } from 'utils/apiUtil'

// メッセージ //================================//
export const usePageMessage = (): [voidStringF, voidF, (data: response<any>) => void] => {
  const dispatch = useDispatch()
  const changePageErrorMessage = useCallback((text: string) => {
    dispatch(PageAction.changeMessageError(text))
  }, [])
  const deletePageMessage = useCallback(() => {
    dispatch(PageAction.deleteMessage())
  }, [])
  const changeMessage = useCallback((data: response<any>) => {
    dispatch(PageAction.changeMessage(data))
  }, [])
  return [changePageErrorMessage, deletePageMessage, changeMessage]
}

/**
 * ローディング //================================//
 */
export const useLoading = (): [boolean, voidBooleanF] => {
  const dispatch = useDispatch()
  // ローディング
  const loading = useSelector((state) => state.PageReducer.loading)
  const changeLoading = useCallback(
    (load: boolean) => {
      dispatch(PageAction.changeLoading(load))
    },
    [loading],
  )

  return [loading, changeLoading]
}

// メッセージ削除しないフラグ //================================//
export const useIsNotDeleteMessage = (): [boolean, voidBooleanF] => {
  const dispatch = useDispatch()
  const isNotDeleteMessage = useSelector((state) => state.PageReducer.isNotDeleteMessage)
  const changeIsNotDeleteMessage = useCallback(
    (isNotDeleteMessage: boolean) => {
      dispatch(PageAction.changeIsNotDeleteMessage(isNotDeleteMessage))
    },
    [isNotDeleteMessage],
  )
  return [isNotDeleteMessage, changeIsNotDeleteMessage]
}

// 検索ボックスを開いているか否か //================================//
export const useExpand = (): [boolean, voidBooleanF] => {
  const dispatch = useDispatch()
  const expand = useSelector((state) => state.PageReducer.expand)
  const changeExpand = () => {
    dispatch(PageAction.changeExpand())
  }
  return [expand, changeExpand]
}
